import React from 'react';
import './Schedule.css';
import logComponent from '../../common/logComponent';
import Schedule from './Schedule';
import { CardScheduleProvider } from '../../contexts/CardScheduleContext';
 
export default function ScheduleCard({ moduleDescription }) {
  if (logComponent('ScheduleCard')) { console.debug('ScheduleCard rendered'); }


  return (
    <CardScheduleProvider>
      <Schedule moduleDescription={moduleDescription} />
    </CardScheduleProvider>
  );
}